module.exports = __webpack_public_path__ + "static/media/2.8acc7b82.jpg";